<div class="page-new-asset-component mat-typography" fxLayout="column" fxLayoutGap="14px">
    <h1 i18n>Create new Asset</h1>

    <div fxLayout="row" fxLayoutGap="14px">

        <div fxLayout="column" fxLayoutGap="14px">
            <app-asset-edit [asset]="asset" (assetChanged)="renderLabel($event)"></app-asset-edit>

            <button mat-raised-button color="primary" i18n="@@createAndPrint" (click)="addPrintAsset()" [disabled]="loading">
                create and print
            </button>
        </div>
        <div>
            <app-label-preview [label]="label" class="new-asset-preview"></app-label-preview>
        </div>

    </div>



</div>